module.exports = "file1";


/*****************
 ** WEBPACK FOOTER
 ** ./runtime/error-handling/folder/file1.js
 ** module id = 1
 ** module chunks = 0
 **/